<template>
  <section
    class="draggable-modules-item-component"
    :class="{ isSubmodule, opened }"
  >
    <div
      class="card"
      :class="{
        opened,
        'indicator px-2_5': isSubmodule
      }"
      @click="openContentCard"
    >
      <div class="d-flex align-items-center gap-2 flex-fill">
        <i class="ph ph-dots-six-vertical handle lead" />
        <h5
          class="module-name text-wrap text-left pr-3"
          :contenteditable="editname"
          @click.stop="onEditName"
          @blur="onBlurName"
          spellcheck="false"
        >
          {{ module.name }}
        </h5>
        <h5 v-if="module.status === 'draft'" class="ml-5 draft-badge">
          Rascunho
        </h5>
      </div>
      <i
        class="ph"
        :class="{
          'ph-caret-up': opened,
          'ph-caret-down': !opened
        }"
      ></i>
      <div class="d-flex align-items-center justify-content-end">
        <snow-actions-dropdown
          :left="false"
          :right="true"
          :actions="actions"
          @edit="$emit('edit', module)"
          @duplicate="$emit('duplicate', module)"
          @remove="$emit('remove', module)"
          @lesson="goToLesson(module)"
          @submodule="goToSubmodule(module)"
          @clone-lesson="cloneLessonModal = true"
          @quiz="goToQuizz(module)"
          toggleClass="p-0 p-2"
        >
        </snow-actions-dropdown>
      </div>
    </div>
    <div
      v-if="opened"
      class="card-body"
      :class="{
        empty: sortedItems.length == 0 && sortedSubModules.length == 0
      }"
    >
      <action-dispatcher
        action="membersModules/getDetails"
        :parameters="module.id"
        @success="onOpenContentModuleContent"
      >
        <div class="d-flex flex-column gap-4">
          <draggable-items
            v-if="sortedItems.length"
            v-model="sortedItems"
            show-list-indicator
            :parent="module"
            group="lessons"
            @edit="item => emitSubItemEvent('edit', item)"
            @duplicate="item => emitSubItemEvent('duplicate', item)"
            @remove="item => emitSubItemEvent('remove', item)"
          />
          <draggable-items
            v-if="sortedSubModules.length"
            v-model="sortedSubModules"
            show-list-indicator
            :parent="module"
            group="submodules"
            @edit="item => emitSubItemEvent('edit', item)"
            @duplicate="item => emitSubItemEvent('duplicate', item)"
            @remove="item => emitSubItemEvent('remove', item)"
          />
          <div
            class="add-buttons"
            :class="{ only_submodules: !sortedItems.length }"
          >
            <div class="btn-dashed flex-fill" @click="goToLesson(module)">
              <i class="ph ph-plus mr-5" />
              <span>Nova Aula</span>
            </div>
            <div class="btn-dashed flex-fill" @click="goToQuizz(module)">
              <i class="ph ph-plus mr-5" />
              <span>Nova Avaliação</span>
            </div>
            <div
              v-if="module.parent === null"
              class="btn-dashed flex-fill"
              @click="goToSubmodule(module)"
            >
              <i class="ph ph-plus mr-5" />
              <span>Novo Submódulo</span>
            </div>
          </div>
        </div>
      </action-dispatcher>
    </div>
    <responsive-modal v-model="cloneLessonModal" title="Copiar aula existente">
      <clone-lesson
        :module="module.id"
        @close="() => (this.cloneLessonModal = false)"
      />
    </responsive-modal>
  </section>
</template>
<script>
import CloneLesson from "@/components/product/details/content/CloneLesson";
import DraggableItems from "@/components/product/details/content/DraggableItems";
import get from "lodash/get";
export default {
  name: "draggable-modules-items",
  components: { DraggableItems, CloneLesson },
  props: {
    isSubmodule: {
      type: Boolean,
      default: false
    },
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const selectedModule = this.$store.state.membersModules.selectedModule;
    return {
      opened:
        this.module.id === selectedModule.parent ||
        this.module.id === selectedModule.id,
      module_data: this.module,
      cloneLessonModal: false,
      editname: false,
      initialName: this.module.name,
      loadingName: false,
      actions: [
        {
          text: this.isSubmodule ? "Editar submódulo" : "Editar módulo",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        ...(this.isSubmodule
          ? []
          : [
              {
                text: "Duplicar módulo",
                class: "",
                icon: "fa-solid fa-clone",
                confirmation: {
                  enable: false
                },
                event: "duplicate"
              }
            ]),
        {
          text: "Nova aula",
          class: "",
          icon: "fa-solid fa-file",
          confirmation: {
            enable: false
          },
          event: "lesson"
        },
        {
          text: "Copiar aula existente",
          class: "",
          icon: "fa-solid fa-clone",
          confirmation: {
            enable: false
          },
          event: "clone-lesson"
        },
        {
          text: "Nova avaliação",
          class: "",
          icon: "fa-solid fa-file-pen",
          confirmation: {
            enable: false
          },
          event: "quiz"
        },
        ...(this.isSubmodule
          ? []
          : [
              {
                text: "Novo submódulo",
                class: "",
                icon: "fa-solid fa-book",
                confirmation: {
                  enable: false
                },
                event: "submodule"
              }
            ]),
        {
          text: "Remover",
          class: "text-danger",
          icon: "fa-solid fa-trash",
          confirmation: {
            enable: true,
            text: this.exclusionMessage(),
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "remove"
        }
      ]
    };
  },
  computed: {
    sortedItems: {
      get() {
        return [...get(this.module_data, "items", [])]
          .filter(item => item.type !== "submodule")
          .sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        const moduleClone = { ...this.module_data };

        const submodules = get(this.module_data, "items", []).filter(
          i => i.type === "submodule"
        );

        val.forEach((item, i) => {
          item.sort = i;
        });

        moduleClone.items = [...val, ...submodules];

        this.module_data = moduleClone;
        this.saveOrderItems();
      }
    },
    sortedSubModules: {
      get() {
        return [...get(this.module_data, "items", [])]
          .filter(item => item.type === "submodule")
          .sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        const moduleClone = { ...this.module_data };

        const lessons = get(this.module_data, "items", []).filter(
          i => i.type !== "submodule"
        );

        val.forEach((item, i) => {
          item.sort = i;
        });

        moduleClone.items = [...lessons, ...val];

        this.module_data = moduleClone;
        this.saveOrderItems();
      }
    }
  },
  methods: {
    openContentCard() {
      if (!this.editname) {
        this.opened = !this.opened;
      }
    },
    onOpenContentModuleContent(data) {
      this.module_data = data;
      const selectedModule = this.$store.state.membersModules.selectedModule;
      if (selectedModule.parent !== data.id)
        this.$store.commit("membersModules/setSelectedModule", data);
    },
    emitSubItemEvent(event, item) {
      this.$emit(event, { ...item, opened_module_id: this.module_data.id });
    },
    exclusionMessage() {
      if (this.group === "modules")
        return "Tem certeza que deseja excluir esse módulo? Serão excluídos todos os submódulos e aulas do módulo.";
      else if (this.group === "lessons")
        return "Tem certeza que deseja excluir essa aula?";
      else
        return "Tem certeza que deseja excluir esse submódulo? Serão excluídas todas as aulas do submódulo.";
    },
    saveOrderItems() {
      this.$store.dispatch(
        "membersModules/reorderItems",
        this.module_data.items
      );
    },
    goToLesson(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-lesson-add",
        params: {
          id: this.$route.params.id
        },
        query: { module_id: item.id }
      });
    },
    goToQuizz(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-module-quizz-add",
        params: {
          id: this.$route.params.id,
          module_id: item.id
        }
      });
    },
    goToSubmodule(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-submodule-add",
        params: {
          id: this.$route.params.id,
          module_id: item.id
        }
      });
    },
    onKeyDownName(e) {
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        this.editname = false;
        return false;
      }
    },
    onEditName() {
      this.editname = true;
      document.addEventListener("keydown", this.onKeyDownName);
    },
    onBlurName(e) {
      if (this.loadingName) return;

      let type = this.isSubmodule ? "submódulo" : "módulo";

      if (!e.target.innerText.trim().length) {
        this.$message.error(`O nome do ${type} não pode ser vazio`);
        e.target.innerText = this.initialName;
      } else if (e.target.innerText.length > 240) {
        this.$message.error(
          `O nome do ${type} não pode ter mais de 240 caracteres`
        );
        e.target.innerText = this.initialName;
      } else {
        const action = this.isSubmodule
          ? "membersModules/putSub"
          : "membersModules/put";
        this.loadingName = true;
        this.$store
          .dispatch(action, { ...this.module, name: e.target.innerText })
          .then(() => {
            this.initialName = e.target.innerText;
            this.$message.success(`O novo nome do ${type} foi salvo`);
          })
          .finally(() => {
            this.loadingName = false;
          });
      }
      this.editname = false;
      document.removeEventListener("keydown", this.onKeyDownName);
    }
  }
};
</script>
<style lang="scss" scoped>
.draggable-modules-item-component {
  width: 100%;
  border-radius: 16px;
  border: 1px solid var(--dark-10);
  background: var(--bg-1);
  transition: 0.3s ease-in;
  &:hover {
    border-color: var(--dark-20);
  }
  &.isSubmodule {
    background: var(--bg-2);
    border: none;
  }

  a,
  a:hover {
    text-decoration: none;
  }
  .ph-dots-six-vertical {
    cursor: pointer;
    color: var(--dark-40);

    &:active {
      cursor: grap;
    }
  }

  .icon-angle-down {
    font-size: 19px;
  }

  .ph-dots-three-vertical {
    color: var(--dark-40);
    padding: 4px 2px;
    border-radius: 8px;
    &:hover {
      background-color: var(--dark-10);
    }
  }

  .card {
    border-radius: 4px;
    border: none;
    background: transparent;
    width: 100%;
    display: flex !important;
    flex-direction: row;
    align-items: center;
    position: relative;
    cursor: pointer;
    padding: 24px;
    gap: 8px;

    &.opened {
      padding: 24px 24px 20px 24px;
    }

    // &:hover {
    //   border: 1px solid var(--dark-40);
    // }
  }

  .module-name {
    font-weight: 600;
    max-width: 70%;
    overflow-wrap: anywhere;
  }

  .card-body {
    position: relative;
    transition: 0.2s all;
    padding: 0px 24px 24px 24px;
  }

  ::v-deep .dropdown-toggle {
    padding: 0px !important;
    min-height: auto;
  }

  ::v-deep.add-buttons {
    display: flex !important;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;

    .btn-dashed {
      border: 1px dashed var(--dark-20);
      border-radius: 16px;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      &:hover {
        border-color: var(--dark-40);
        background: var(--dark-4);
      }
    }

    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
  }
  .btn-outline-primary-dashed {
    border-style: dashed;
    border-color: rgba(31, 80, 255, 0.5);
  }
}
</style>
